export const featuresCods = {
  TRUSTED_DESTINATIONS: 'trusted-destinations',
  PENDING_LINKS: 'pending-links',
  E_LINKS: 'e-link',
  OBSERVE_POINT: 'observepoint',
};

export default featuresCods;
